import {Fragment} from 'react';

import {PaymentTypeService as Service} from './PaymentTypeService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {useTranslation} from '../../../shared/language';

export const List = () => {

  const {t} = useTranslation();
  const header = t('catalog.paymentMethod');
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'code', header: t('catalog.paymentCode'), width: 200, matchMode: 'contains'},
      {field: 'name', header: t('catalog.paymentName'), minWidth: 250, matchMode: 'contains'},
      {field: 'maxValuePayment', header: t('catalog.paymentMaximumValue'), width: 150, dataType: 'number'},
      {field: 'description', header: t('common.description'), minWidth: 250, matchMode: 'contains'}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {field: 'code', header: t('catalog.paymentCode'), required: true, uppercase: true, InputTextProps: {maxLength: 50}, className: 'md:col-12'},
      {field: 'name', header: t('catalog.paymentName'), required: true, InputTextProps: {maxLength: 400}, className: 'md:col-12'},
      {field: 'maxValuePayment', header: t('catalog.paymentMaximumValue'), type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-12'},
      {field: 'description', header: t('common.description'), InputTextProps: {maxLength: 400}, className: 'md:col-12'}
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem(id: string): Promise<any> {
      return Service.delete(id);
    },
    deleteItems(ids: Array<any>): Promise<any> {
      return Service.deleteMulti(ids);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
